import { memo, useEffect, useState } from 'react';

import CustomReactMarkdown from '../custom-markdown/custom-markdown';

export const MessageWithDelay = memo(
  ({
    text,
    delay,
    withMarkdown,
    isError,
  }: {
    text: string;
    delay: number;
    withMarkdown?: boolean;
    isError?: boolean;
  }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [currentCharIndex, setCurrentCharIndex] = useState(0);

    useEffect(() => {
      if (currentCharIndex >= text.length) return;

      const interval = setInterval(() => {
        setDisplayedText((prev) => prev + text[currentCharIndex]);
        setCurrentCharIndex((prevIndex) => prevIndex + 1);

        if (currentCharIndex + 1 >= text.length) {
          clearInterval(interval);
        }
      }, delay);

      return () => clearInterval(interval);
    }, [text, delay, currentCharIndex]);

    return withMarkdown ? (
      <CustomReactMarkdown isError={isError}>{displayedText}</CustomReactMarkdown>
    ) : (
      displayedText
    );
  },
);
